import { createSelector } from 'reselect';

const selectContras = (state: any) => state.contras;

export const selectContrasCurrentItem = createSelector([selectContras], (contras) => contras.current);

export const selectContrasListItems = createSelector([selectContras], (contras) => contras.list);

export const selectContrasItemById = (itemId: any) =>
    createSelector(selectContrasListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectContrasQueryItems = createSelector([selectContras], (contras) => contras.query);

export const selectContrasCreatedItem = createSelector([selectContras], (contras) => contras.create);

export const selectContrasUpdatedItem = createSelector([selectContras], (contras) => contras.update);

export const selectContrasReadItem = createSelector([selectContras], (contras) => contras.read);

export const selectContrasDeletedItem = createSelector([selectContras], (contras) => contras.delete);

export const selectContrasSearchedItems = createSelector([selectContras], (contras) => contras.search);

export const selectContrasItemsCount = createSelector([selectContras], (contras) => contras.count);

export const selectContrasItemsFilter = createSelector([selectContras], (contras) => contras.filter);